import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Pagination } from "swiper/modules";
import * as urls from "../../utils/URLConst";
import { computeCrc } from "../../utils/CRC32";
import axios from "axios";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { AuthKey } from "../../utils/Common";
import InquiryModal from "../modal/Inquiry/InquiryModal";
import { useDispatch } from "react-redux";
import { handleLoader } from "../../redux/reducers/layout";

const SwiperCarsouel = ({ count }) => {
  const [product, setProduct] = useState([]);
  const [isInquiryMdl, setIsInquiryMdl] = useState(false);
  const [inquiryData, setInquiryData] = useState(null);
  const dispatch = useDispatch();

  const handleInquiryOfProduct = (data) => {
    setInquiryData(data || null);
    setIsInquiryMdl(!isInquiryMdl);
  }

  async function fetchProductServiceLink() {
    try {
      dispatch(handleLoader(true));
      const payload = {
        FLAG: "A",
      };
      const checksum = computeCrc(JSON.stringify(payload));
      await axios({
        method: "POST",
        url: urls.getProductServiceLink,
        data: payload,
        ...{
          headers: {
            "Content-Type": "application/json",
            checksum: checksum,
            Authorization: AuthKey,
          },
        },
      }).then((result) => {
        if (result.data.STATUS === "0") {
          const response = result.data.RESPONSE;
          setProduct(response ?? []);
        } else {
        }
      });
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  useEffect(() => {
    fetchProductServiceLink();
  }, []);

  const [loadedCount, setLoadedCount] = useState(0);

  const handleImageLoad = () => {
    setLoadedCount((prev) => prev + 1);
  };

  return (
    <>
      {product.map((data, index) => {
        return (
          <React.Fragment key={index}>
            {data.DTL.length > 0 &&
              <div className="h-auto">
                <h6 className="text-sm fw-semibold">
                  {data.CAT_NM}
                </h6>
                <Swiper
                  slidesPerView={count ? count : 3}
                  spaceBetween={30}
                  freeMode={true}
                  pagination={{
                    clickable: true,
                  }}
                  autoplay={{ delay: 3000 }}
                  modules={[Autoplay, FreeMode, Pagination]}
                  className="mySwiper"
                >
                  {data.DTL.slice(0, loadedCount + 1).map((value, index) => (
                    <SwiperSlide key={index}>
                      <div className="slider-link" onClick={() => handleInquiryOfProduct(value)}>
                        <div className="item" style={{ cursor: "pointer" }}>
                          <div
                            style={{ width: "100%" }}
                            className="swiper-product-img mt-1 card border-dashboard-card"
                          >
                            <img
                              src={
                                value.IMG
                                  ? value.IMG
                                  : "/assets/images/default_product_img.jpeg"
                              }
                              alt=""
                              onLoad={handleImageLoad}
                              width={10}
                            />
                          </div>
                          <div
                            className="text-sm text-slate-500"
                            title={value.ITEM_NM}
                          >
                            {`${value.ITEM_NM.slice(0, 25)}`}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                <hr />
              </div>
            }
          </React.Fragment>
        );
      })}

      {isInquiryMdl && (
        <InquiryModal
          isOpen={isInquiryMdl}
          handleProductDtlMdl={handleInquiryOfProduct}
          inquiryData={inquiryData}
        />
      )}
    </>
  );
};

export default SwiperCarsouel;
